const buttonMixin = {
    props: ['text', 'disabled'],
    emits: ['click']
}

export default buttonMixin